import { FC, SVGProps } from 'react';

const TeamIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M2.63818 16.6666C2.63818 14.9094 4.02455 12.7216 8.0205 12.7216C12.0157 12.7216 13.402 14.8935 13.402 16.6515"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.4583 6.77155C11.4583 8.67041 9.91918 10.2096 8.02027 10.2096C6.12217 10.2096 4.58301 8.67041 4.58301 6.77155C4.58301 4.87266 6.12217 3.3335 8.02027 3.3335C9.91918 3.3335 11.4583 4.87266 11.4583 6.77155Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.417 12.4546C16.6732 12.9178 17.3616 14.5508 17.3616 15.8043"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.6538 4.72021C14.8141 4.96216 15.6831 5.99198 15.6792 7.22316C15.6752 8.31267 14.9884 9.24066 14.0238 9.60116"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TeamIcon;
